import React from 'react';
import PropTypes from 'prop-types';

import { bindingClassName } from '~/utils';

/**
 * ----------------------------------------------------------------------------
 * Level right component
 * ----------------------------------------------------------------------------
 *
 * @param {{ children: JSX.Element }} props
 * @returns
 */
function Right ({ children, className, style }) {
  return (
    <div
      style={style}
      className={bindingClassName(
        'level-right',
        className,
      )}
    >
      {children}
    </div>
  );
}

Right.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  className: PropTypes.string,
  style: PropTypes.shape(),
};

Right.defaultProps = {
  className: '',
  style: {},
};

export default Right;
